import { cn } from "@/lib/utils";
import { customerInitials } from "./customerInitials";


interface BookingCustomerAvatarProps {
  name: string;
  /** Dim for settled bookings (completed / cancelled). */
  muted?: boolean;
  className?: string;
}

/** Small tinted initials tile for booking rows. */
export function BookingCustomerAvatar({
  name,
  muted = false,
  className,
}: BookingCustomerAvatarProps) {
  return (
    <span
      className={cn(
        "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-xs font-semibold ring-1 ring-inset",
        muted
          ? "bg-surface-100 text-surface-500 ring-surface-500/10"
          : "bg-primary-50 text-primary-700 ring-primary-600/15",
        className,
      )}
      aria-hidden
    >
      {customerInitials(name)}
    </span>
  );
}
